// import { Outlet } from "react-router-dom";
// import { useAppSelector } from "../../app/hooks";
// import Login from "../../Pages/Login/Login";
// import AppLayout from "../layout/app-layout";
// import ChoiceScreen from "Pages/Login/ChoiceScreen";

// export const AuthenticatedRoute = () => {
//   const { authenticated } = useAppSelector((state) => state.appData);

//   const isAuthenticated =
//     authenticated || !!localStorage.getItem("user-details");

//   return isAuthenticated ? (
//     <AppLayout>
//       <Outlet />
//     </AppLayout>
//   ) : (
//     // <Login env={process.env} />
//     <ChoiceScreen />
//   );
// };


// import { Outlet } from 'react-router-dom';
// import { useAppSelector } from '../../app/hooks';
// import Login from '../../Pages/Login/Login';
// import AppLayout from '../layout/app-layout';
// import ChoiceScreen from 'Pages/Login/ChoiceScreen';

// export const AuthenticatedRoute = () => {
//   const { authenticated } = useAppSelector((state) => state.appData);

//   const isAuthenticated = authenticated || !!localStorage.getItem('user-details');

//   return isAuthenticated ? (
//     <AppLayout>
//       <Outlet />
//     </AppLayout>
//   ) : (
//     // <Login env={process.env} />
//     <ChoiceScreen />
//   );
// };

import { Outlet, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AppLayout from '../layout/app-layout';
import { LoginSignupState } from 'types/loginSignUpTypes';

export const AuthenticatedRoute = () => {
  const { isAuthenticated } = useSelector(
    (state: { loginSignup: LoginSignupState }) => state.loginSignup
  );

  const hasUserDetails = !!localStorage.getItem('user-details');

  return isAuthenticated || hasUserDetails ? (
    <AppLayout>
      <Outlet />
    </AppLayout>
  ) : (
    <Navigate to="/login" replace />
  );
};